import { render, staticRenderFns } from "./PersonFiles.vue?vue&type=template&id=27c34da1&scoped=true"
import script from "./PersonFiles.vue?vue&type=script&lang=js"
export * from "./PersonFiles.vue?vue&type=script&lang=js"
import style0 from "./PersonFiles.vue?vue&type=style&index=0&id=27c34da1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c34da1",
  null
  
)

export default component.exports